import {useTranslation} from 'react-i18next';
import * as css from '../menu.css';
import {MessageTypeConfig, MessageTypeItemProps} from '../types';
import useMobile from '../../../../hooks/useMobile';
import {useParams} from 'react-router-dom';
import Chevron from '../../../../assets/icons/Chevron';
import {STRONG_BLUE} from '../../../../globalVariables/GlobalVariables';

function MessageTypeItem({
    mType,
    isSelected,
    isOpen,
    messageConfig,
    onSelect,
    deliveryTypesLength,
    children
}: MessageTypeItemProps): JSX.Element {
    const {t} = useTranslation('branding');
    const isMobile = useMobile();
    const {pageId: deliveryType} = useParams();

    return (
        <div key={mType}>
            <css.DropdownItem
                $open={isOpen || isSelected && isMobile}
                $selected={isSelected}
                onClick={() => onSelect(mType)}
            >
                {messageConfig.icon}
                {t(mType)}
                {isMobile && isSelected && <><Chevron className="chevron" fill={STRONG_BLUE} /> {t(deliveryType)}</>}
            </css.DropdownItem>
            <css.subMenu $selected={isSelected && isOpen} deliveryTypesLength={deliveryTypesLength}>
                {children}
            </css.subMenu>
        </div>
    );
}
export default MessageTypeItem;
